'use client';

import { TabPanel, tabPanelTag } from '@ni/nimble-components/dist/esm/tab-panel';
import { wrap } from '../utilities/react-wrapper';

export { tabPanelTag };
export { type TabPanel };
export const NimbleTabPanel = wrap(TabPanel);
